/**
 * Loader de las rutas del landing (JOP-75): un parcel en vez del string
 * `gifLoader`.
 *
 * single-spa-layout 1.6.0 monta el loader de una aplicación con
 * `mountRootParcel(loader, { name, domElement })` sobre el contenedor
 * `#single-spa-application:@jopit/landing`, que reutiliza por id si ya existe. Con
 * el HTML prerenderizado ese contenedor llega con el contenido de la página, y el
 * loader string hace `domElement.innerHTML = <video>`: contenido → spinner →
 * contenido. Este parcel:
 *
 * - `mount`: si el contenedor trae `data-prerendered`, no hace nada; si no, pinta el
 *   mismo spinner que `gifLoader` y se acuerda de que pintó ESE contenedor.
 * - `unmount`: limpia sólo si su `mount` pintó. single-spa-layout lo desmonta
 *   justo antes de montar la aplicación; si limpiara siempre, borraría el
 *   fragmento antes de que el landing lo reemplace (frame vacío).
 *
 * Fuera del primer render (navegación SPA en frío hacia una ruta del landing) el
 * contenedor no trae `data-prerendered` y el spinner se ve como siempre.
 */

export const PRERENDERED_ATTRIBUTE = "data-prerendered";

/**
 * @param {string} loaderHtml el HTML del spinner (el mismo de `gifLoader`).
 */
export function createLandingLoader(loaderHtml) {
    const painted = new WeakSet();

    return {
        bootstrap() {
            return Promise.resolve();
        },
        mount({ domElement }) {
            return Promise.resolve().then(() => {
                if (!domElement || domElement.hasAttribute(PRERENDERED_ATTRIBUTE)) {
                    return;
                }
                domElement.innerHTML = loaderHtml;
                painted.add(domElement);
            });
        },
        unmount({ domElement }) {
            return Promise.resolve().then(() => {
                if (!domElement || !painted.has(domElement)) {
                    return;
                }
                painted.delete(domElement);
                domElement.innerHTML = "";
            });
        },
    };
}
